// @flow
import Passenger from "@kiwicom/frontend-app/scripts/containers/mutable/Passenger"

import jsonFetch from "common/services/fetch/jsonFetch"
import type Options from "common/records/Options"
import formatTimestamptToISO from "common/utils/formatTimestampToISO"
// Types
import Journey from "common/records/Journey"
import type { Service } from "booking/services/ancillaries3rd/services/types"
import ANCILLARY_SERVICES, { type AncillaryService } from "./consts"

// Developers use camel case for service names "paidCheckin", "fastTrack", etc...
// But our system accepts snake case names so we need to serialize service names
const parseServiceName = (serviceName: AncillaryService): Service => ANCILLARY_SERVICES[serviceName]

const parseAncillary = (serviceName: Service) => ({ service: serviceName })

export const parseItinerary = (flights: any) =>
  flights.map(f => ({
    source: f.src,
    destination: f.dst,
    departure: formatTimestamptToISO(f.dtime),
    arrival: formatTimestamptToISO(f.atime),
    carrier: {
      operating: {
        code: f.operating_airline.iata,
      },
    },
    vehicle: {
      type: f.vehicle.type,
    },
    segment_code: f.id,
    carrier_segment_code: f.flight_no,
  }))

export default (
  journey: Journey,
  passengers: Passenger[] = [],
  options: Options,
  ancillaries: AncillaryService[],
) =>
  jsonFetch(`${options.get("ancillariesApiUrl")}/offers`, {
    method: "POST",
    body: {
      passengers,
      itinerary: parseItinerary(journey.get("_original").flights),
      ancillaries: ancillaries.map(parseServiceName).map(parseAncillary),
    },
  })
